import React, { FC } from 'react';
import { type IconV2Props } from '../../IconV2';
import { cn } from '@express-labs/raven-tools';
import s from '../../IconV2.scss';

const opacityMap: OpacityMap = {
  default: '0.4',
  hover: '0.6',
  dark: '0.9',
};

const DCPlay32: FC<IconV2Props> = ({ icon, chroma, className }) => {
  const chromaType = chroma as string;
  const opacity = opacityMap[chromaType] || '';
  return (
    <svg
      className={cn(s.svg32, `svg-icon--${icon}`, className)}
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      data-icon={`${icon}-32`}
    >
      <g
        id="Video-Content"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g id="UI-Sheet" transform="translate(-112.000000, -158.000000)">
          <g id="Group-4" transform="translate(86.000000, 158.000000)">
            <g
              id="videoControllerPlay"
              transform="translate(26.000000, 0.000000)"
            >
              <g id="controllerbg(60%)" fill="#000000" fillOpacity={opacity}>
                <ellipse
                  id="Oval"
                  cx="15.5151515"
                  cy="16"
                  rx="15.5151515"
                  ry="16"
                />
              </g>
              <g
                id="Play"
                transform="translate(13.000000, 11.000000)"
                fill="#FFFFFF"
                fillRule="nonzero"
              >
                <polygon
                  id="Triangle"
                  transform="translate(4.000000, 5.000000) rotate(90.000000) translate(-4.000000, -5.000000) "
                  points="4 1 9 9 -1 9"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export default DCPlay32;
